import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col space-y-5" }
const _hoisted_2 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Transactions ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row space-x-2" }, null, -1)
const _hoisted_5 = { class: "w-full grid grid-cols-12 gap-3 px-3 border-[1px] border-grey300 rounded-md" }
const _hoisted_6 = { class: "w-full grid grid-cols-1 gap-4" }
const _hoisted_7 = { class: "col-span-full w-full flex flex-col space-y-2 rounded-md border-[1px] border-grey300 px-6 py-6" }
const _hoisted_8 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Pending booking payouts ")
const _hoisted_10 = { class: "flex flex-row space-x-3 items-center" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Update payout schedule")
const _hoisted_12 = { class: "w-full flex flex-col py-3" }
const _hoisted_13 = { class: "col-span-full w-full flex flex-col space-y-2 rounded-md border-[1px] border-grey300 px-6 py-6" }
const _hoisted_14 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" All Transactions ")
const _hoisted_16 = { class: "w-full flex flex-col py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_roof_header_text = _resolveComponent("roof-header-text")!
  const _component_roof_growth_box = _resolveComponent("roof-growth-box")!
  const _component_roof_financial_chart = _resolveComponent("roof-financial-chart")!
  const _component_roof_button = _resolveComponent("roof-button")!
  const _component_roof_table = _resolveComponent("roof-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_roof_header_text, { size: "xl" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_roof_growth_box, {
        label: 'Total Inflow',
        "growth-data": _ctx.financialData?.GetFinancialsOverview.credit_amount,
        "is-currency": true
      }, null, 8, ["growth-data"]),
      _createVNode(_component_roof_growth_box, {
        label: 'Total Outflow',
        "growth-data": _ctx.financialData?.GetFinancialsOverview.debit_amount,
        "is-currency": true
      }, null, 8, ["growth-data"]),
      _createVNode(_component_roof_growth_box, {
        label: 'Users Wallet Balance',
        "growth-data": _ctx.financialData?.GetFinancialsOverview.user_wallet_balance,
        "is-currency": true
      }, null, 8, ["growth-data"]),
      _createVNode(_component_roof_growth_box, {
        label: 'Providers Wallet Balance',
        "growth-data": 
          _ctx.financialData?.GetFinancialsOverview.provider_wallet_balance
        ,
        "is-currency": true
      }, null, 8, ["growth-data"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_roof_financial_chart, {
        data: _ctx.CreditDebitStatisticsData,
        label: 'Earning Statistics',
        itemLabel1: "Inflow",
        itemLabel2: "Outflow",
        dateDifference: 12,
        chartHeight: '!h-[320px]',
        "container-height": 'h-[340px]',
        "data-source": _ctx.Logic.Financials.GetCreditDebitStatistics
      }, null, 8, ["data", "data-source"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_roof_header_text, { size: "lg" }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _createVNode(_component_roof_header_text, null, {
          default: _withCtx(() => [
            _createTextVNode("Total : " + _toDisplayString(_ctx.Logic.Common.convertToMoney(
              _ctx.financialData.GetFinancialsOverview.pending_payouts.count,
              true,
              '',
              false,
              'NGN '
            )), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_roof_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showUpdatePayoutSchedule()))
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_roof_table, {
          tableStructure: _ctx.Logic.Booking.BookingTableStructure,
          paginatedData: _ctx.PendingBookingPayouts,
          "table-date-source": _ctx.Logic.Booking.BookingSource,
          "extra-query": _ctx.extraBookingQuery,
          "sub-page-route": '/bookings/',
          "query-options-to-hide": [0]
        }, null, 8, ["tableStructure", "paginatedData", "table-date-source", "extra-query"])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_roof_header_text, { size: "lg" }, {
          default: _withCtx(() => [
            _hoisted_15
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_roof_table, {
          tableStructure: _ctx.Logic.Financials.TransactionTableStructure,
          paginatedData: _ctx.financialData.Transactions,
          "table-date-source": _ctx.Logic.Financials.TransactionsSource,
          "sub-page-route": '/financials/transactions/'
        }, null, 8, ["tableStructure", "paginatedData", "table-date-source"])
      ])
    ])
  ]))
}